import jwtInterceptor from "./autorizacao/jwt-interceptor";

class ServicosCep {
    consultaCep(cep){
        return jwtInterceptor.get(`https://viacep.com.br/ws/${cep}/json/`)
    }
}

export default new ServicosCep();